/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./chat-bot-button.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../shared/translate.pipe";
import * as i3 from "../../shared/translation.service";
import * as i4 from "./chat-bot-button.component";
var styles_ChatBotButtonComponent = [i0.styles];
var RenderType_ChatBotButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ChatBotButtonComponent, data: {} });
export { RenderType_ChatBotButtonComponent as RenderType_ChatBotButtonComponent };
export function View_ChatBotButtonComponent_0(_l) { return i1.ɵvid(2, [i1.ɵpid(0, i2.TranslatePipe, [i3.TranslationService]), (_l()(), i1.ɵeld(1, 0, null, null, 0, "img", [["class", "avatar"], ["src", "/images/chat-bot/bot.png"]], null, null, null, null, null)), (_l()(), i1.ɵeld(2, 0, null, null, 2, "button", [["class", "button d-md-none d-lg-none d-xl-inline"]], null, null, null, null, null)), (_l()(), i1.ɵted(3, null, ["", ""])), i1.ɵppd(4, 1)], null, function (_ck, _v) { var currVal_0 = i1.ɵunv(_v, 3, 0, _ck(_v, 4, 0, i1.ɵnov(_v, 0), "chatBot.banner.cta")); _ck(_v, 3, 0, currVal_0); }); }
export function View_ChatBotButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-chat-bot-button", [], null, null, null, View_ChatBotButtonComponent_0, RenderType_ChatBotButtonComponent)), i1.ɵdid(1, 49152, null, 0, i4.ChatBotButtonComponent, [], null, null)], null, null); }
var ChatBotButtonComponentNgFactory = i1.ɵccf("lp2-chat-bot-button", i4.ChatBotButtonComponent, View_ChatBotButtonComponent_Host_0, {}, {}, []);
export { ChatBotButtonComponentNgFactory as ChatBotButtonComponentNgFactory };
//# sourceMappingURL=chat-bot-button.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/header/chat-bot-button/chat-bot-button.component.ngfactory.js
// module id = 1462
// module chunks = 27 28 29